module.exports = __webpack_public_path__ + "static/media/logoprojeto1.9ca63585.png";